/**
 * Origem que dispara o match de um evento dinamico da LLM.
 * Espelha o enum backend FieldService.Business.Enums.LLMEventSourceType.
 *
 * - USER_MESSAGE (1): match roda ANTES da LLM ser chamada, contra a mensagem
 *   do cliente. Se casar, o fluxo pula pra proxima caixa e a LLM nao eh
 *   invocada. Comportamento historico.
 *
 * - LLM_RESPONSE (2): match roda DEPOIS da LLM responder, contra o texto que
 *   ela acabou de gerar. Se casar, o fluxo pula pra proxima caixa. Se o
 *   evento tiver `suppressLlmMessage=true`, a resposta NAO eh entregue ao
 *   usuario final (silent) — util pra padroes tipo "LLM escreve um marcador
 *   de estado que o motor deve detectar sem mostrar ao cliente".
 */
export const LLM_EVENT_SOURCE = Object.freeze({
    USER_MESSAGE: 1,
    LLM_RESPONSE: 2,
});

/**
 * Constroi as opcoes prontas pro Autocomplete/select, com labels ja
 * traduzidos via intl. Uso: `getLlmEventSourceOptions(intl)`.
 */
export const getLlmEventSourceOptions = (intl) => ([
    {
        id: LLM_EVENT_SOURCE.USER_MESSAGE,
        label: intl.formatMessage({ id: 'llm.event.source.user_message' }),
    },
    {
        id: LLM_EVENT_SOURCE.LLM_RESPONSE,
        label: intl.formatMessage({ id: 'llm.event.source.llm_response' }),
    },
]);
